import axios from '../../axios'
import { takeLatest, call, put } from 'redux-saga/effects'
import { createAction, Action } from 'redux-actions'

// Saga action strings
export const GET_DISTRICTS = 'saga/School/GET_DISTRICTS'
export const GET_DISTRICTS_SUCCESS = 'saga/School/GET_DISTRICTS_SUCCESS'
export const GET_DISTRICTS_FAILURE = 'saga/School/GET_DISTRICTS_FAILURE'
export const GET_SCHOOLS = 'saga/School/GET_SCHOOLS'
export const GET_SCHOOLS_SUCCESS = 'saga/School/GET_SCHOOLS_SUCCESS'
export const GET_SCHOOLS_FAILURE = 'saga/School/GET_SCHOOLS_FAILURE'

export const actions = {
  GET_DISTRICTS,
  GET_DISTRICTS_SUCCESS,
  GET_DISTRICTS_FAILURE,
  GET_SCHOOLS,
  GET_SCHOOLS_SUCCESS,
  GET_SCHOOLS_FAILURE
}

type DistrictSchoolActionCreators = {
  fetchDistricts: () => Action<any>,
  fetchDistrictsSuccess: any => Action<any>,
  fetchDistrictsFailure: object => Action<any>,
  fetchSchools: () => Action<any>,
  fetchSchoolsSuccess: any => Action<any>,
  fetchSchoolsFailure: object => Action<any>
}

export const actionCreators: DistrictSchoolActionCreators = {
  fetchDistricts: createAction(GET_DISTRICTS),
  fetchDistrictsSuccess: createAction(GET_DISTRICTS_SUCCESS),
  fetchDistrictsFailure: createAction(GET_DISTRICTS_FAILURE),
  fetchSchools: createAction(GET_SCHOOLS),
  fetchSchoolsSuccess: createAction(GET_SCHOOLS_SUCCESS),
  fetchSchoolsFailure: createAction(GET_SCHOOLS_FAILURE)
}

export default function * watchDistrictSchool () {
  yield takeLatest(GET_DISTRICTS, getDistricts)
  yield takeLatest(GET_SCHOOLS, getSchools)
}

export function * getDistricts (action) {
  try {
    const districts = yield call(axios.get, 'districts')

    const activeDistricts = districts.data.filter(function (chunk) {
      return chunk.is_district_active === true
    })
    const inactiveDistricts = districts.data.filter(function (chunk) {
      return chunk.is_district_active !== true
    })
    districts.data = activeDistricts
    districts.inactiveDistricts = inactiveDistricts
    yield put(actionCreators.fetchDistrictsSuccess(districts.data))
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      yield put(
        actionCreators.fetchDistrictsFailure(error.response.data.errors[0])
      )
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      yield put(actionCreators.fetchDistrictsFailure(error.request))
    } else {
      // Something happened in setting up the request that triggered an Error
      yield put(actionCreators.fetchDistrictsFailure(error.message))
    }
  }
}

export function * getSchools (action) {
  try {
    const schools = yield call(
      axios.get,
      `districts/${action.payload.code}/schools`
    )
    const activeSchools = schools.data.filter(function (chunk) {
      // return chunk.is_school_active === true
      return true
    })
    const inactiveSchools = schools.data.filter(function (chunk) {
      return chunk.is_school_active !== true
    })

    schools.data = activeSchools
    schools.inactiveSchools = inactiveSchools

    yield put(actionCreators.fetchSchoolsSuccess(schools.data))
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      yield put(actionCreators.fetchSchoolsFailure(error.response.data.status))
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      yield put(actionCreators.fetchSchoolsFailure(error.request))
    } else {
      // Something happened in setting up the request that triggered an Error
      yield put(actionCreators.fetchSchoolsFailure(error.message))
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/districtSchool/districtSchoolSaga.js